import type { ApplicationState } from './types'
import { DEFAULT_PAGE_ROWS } from 'core/constants'

export const state: ApplicationState = {
  application: {} as any,
  applications: [],
  selectedRows: DEFAULT_PAGE_ROWS,
  currentPage: 1,
  logsInWeek: [],
  totalLogsInWeek: 0,
  errorLogsInWeek: 0,
  successLogsInWeek: 0,
  selectedApplicationIds: undefined as any,
}
